module.exports = __webpack_public_path__ + "static/media/yellow-orange-tape.93a6f6b5.png";